module.exports = {"id":"%{id}","title":"%{title}","description":"%{description}","type":"discount","displayCondition":{"type":"false"},"condition":{"type":"false"},"operator":{"type":"value","value":0},"state":"closed"}


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wixrest-utils/dist/openrest-helpers/ChargeV2.template.discount.deleted.json
// module id = 965
// module chunks = 0